function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.218 4.286l2.977-2.64c.702-.623.2-1.646-.752-1.646H9.036c-.3 0-.551.089-.752.267L2.92 5.025c-.401.4-.401 1.023 0 1.379l5.364 4.758c.2.178.452.267.752.267h2.407c.953 0 1.454-1.023.752-1.646l-2.51-2.225H15c5.35 0 9.694 4.284 9.694 9.571 0 5.293-4.349 9.599-9.694 9.599-5.345 0-9.694-4.306-9.694-9.599 0-.903-.74-1.636-1.653-1.636S2 16.226 2 17.13C2 24.23 7.828 30 15 30c7.168 0 13-5.766 13-12.844 0-7.1-5.828-12.87-13-12.87H9.218z",
  fill: "currentColor"
})));